export default __webpack_public_path__ + "static/capabilitiesImg3-b0bd94830f5eb89b6b44ee6776526d49.webp";